import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AppRoutingConstants } from "../../../app-routing.constants";
export class ApplicationSummaryConstants {
    static CATEGORY_LABEL = "Limit summary to a category";
    static CATEGORY_PLACEHOLDER = "All categories";
    static CATEGORY_FORM_CONTROL_NAME = "category";
    static APPLICANT_TEXT = "Applicant";
    static APPLICATION_ID_TEXT = "App ref";
    static STATUS_TEXT = "Status";
    static DAYS_LEFT_TEXT = "Days left";
    static FIVE_DAYS_AGO_TEXT = "5 Days Ago";
    static OVERDUE_TEXT = "Overdue";
    static DAYS_OVERDUE_TEXT = "Days overdue";
    static OVERDUE_ID = "OverdueId";
    static FIVE_DAYS_AGO_ID = "FiveDaysAgoId";
    static IN_PROGRESS_TEXT = "In Progress";
    static DAYS_LIMIT = SharedConstants.DAYS_LIMIT;
    static VIEW_APPLICATION_ROUTE = AppRoutingConstants.createRouteToView("view-application");
    static VIEW_APPLICATIONS = AppRoutingConstants.createRouteToView("applications");
}
